import { useEffect, useState } from "react";
import { useParams } from "react-router";
import type { PublicHomeShare } from "@handvero/shared";
import { api, errorText } from "../api";
import "./unterlagen.css";

/* Seite für den Betrieb: Über den Link aus der Mail sieht er den geteilten Ordner, ohne Konto, nur lesend. */

const day = (iso: string) => new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
const size = (n: number) => (n < 1024 * 1024 ? `${Math.max(1, Math.round(n / 1024))} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`);

export function Akte() {
  const { token = "" } = useParams();
  const [share, setShare] = useState<PublicHomeShare | null>(null);
  const [error, setError] = useState("");
  const base = `/api/public/akte/${encodeURIComponent(token)}`;

  useEffect(() => {
    document.title = "Geteilte Unterlagen";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    api.get<PublicHomeShare>(base).then(setShare, (err) => setError(errorText(err)));
    return () => robots.remove();
  }, [base]);

  return (
    <div className="ul-page">
      <main className="ul-card">
        {error ? (
          <>
            <h1>Link nicht verfügbar</h1>
            <p className="ul-error" role="alert">
              {error}
            </p>
          </>
        ) : !share ? (
          <div className="ul-loading" role="status" aria-label="Wird geladen" />
        ) : (
          <>
            <h1>Unterlagen von {share.sender}</h1>
            <p className="ul-note">
              Ordner „{share.folderName}“, geteilt mit {share.tradesperson}. Sie können alles ansehen und herunterladen.
            </p>
            {share.message && (
              <blockquote className="ul-msg">
                <p>{share.message}</p>
                <cite>{share.sender}</cite>
              </blockquote>
            )}
            {share.files.length === 0 ? (
              <p>In diesem Ordner liegen noch keine Dateien.</p>
            ) : (
              <ul className="ul-list">
                {share.files.map((f) => (
                  <li key={f.id}>
                    <span className="ul-ico" aria-hidden="true">
                      {f.image ? "FOTO" : f.kind === "pdf" ? "PDF" : "DATEI"}
                    </span>
                    <span className="ul-text">
                      <b>{f.name}</b>
                      <small>
                        {f.folder} · {size(f.size)}
                      </small>
                    </span>
                    <span className="ul-btns">
                      <a className="ul-btn ghost" href={`${base}/files/${f.id}`} target="_blank" rel="noreferrer">
                        Ansehen
                      </a>
                      <a className="ul-btn" href={`${base}/files/${f.id}?download=1`} download>
                        Herunterladen
                      </a>
                    </span>
                  </li>
                ))}
              </ul>
            )}
            <p className="ul-note">
              Dieser Link ist bis zum {day(share.expiresAt)} gültig. Die Angaben stammen von {share.sender}. Rückfragen beantwortet {share.sender} direkt, antworten Sie auf die E-Mail.
            </p>
          </>
        )}
      </main>
      <footer className="ul-foot">
        Bereitgestellt mit{" "}
        <a href="/" className="ul-brand">
          <span>Hand</span>Vero
        </a>{" "}
        · <a href="/rechtliches">Impressum und Datenschutz</a>
      </footer>
    </div>
  );
}
